import type { Profile } from '$lib/types'

export const profileColors: { [key in Profile['color']]: string } = {
  blue: 'var(--color-blue-1)',
  green: 'var(--color-green-1)',
  yellow: 'var(--color-yellow-2)',
  red: 'var(--color-red-1)',
  purple: 'var(--color-purple-1)',
  gray: 'var(--color-gray-1)',
}

export const CONCRETE_PROFILE_COLORS = {
  blue: '#e1f6ff',
  green: '#e2f8ef',
  yellow: '#fff1aa',
  red: '#ffece8',
  purple: '#f7eeff',
  gray: '#f3f1f2',
}
